import { DATA_RETENTION_DURAION_MAX, DATA_RETENTION_DURAION_MIN, DATA_SUB_PROCESSOR_KEY, THIRD_PARTY_KEY } from '../../constants';
export const transformValueForThirdPartyEntityQuestion = formData => {
  return formData[THIRD_PARTY_KEY] || formData[DATA_SUB_PROCESSOR_KEY];
};
export const transformValueForDataRetention = formData => {
  return {
    [DATA_RETENTION_DURAION_MIN]: formData[DATA_RETENTION_DURAION_MIN],
    [DATA_RETENTION_DURAION_MAX]: formData[DATA_RETENTION_DURAION_MAX]
  };
};